export function formatCurrency(
  amount: number,
  locale = "en-US",
  currency: string | null | undefined = "USD"
): string {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency ?? "USD",
  }).format(amount);
}

// Convert cents to dollars and format as currency
export function formatCentsAsCurrency(
  cents: number | null | undefined,
  currency: string | null | undefined = "USD",
  locale = "en-US"
): string {
  if (cents == null) {
    return formatCurrency(0, locale, currency);
  }
  return formatCurrency(cents / 100, locale, currency);
}
